class PageRoutes {
  static readonly LoginPage: string = "/login";
  static readonly AdvisoryScreenPage: string = "/advisory";
  static readonly UsersPage: string = "/users";
  static readonly HistoryPage: string = "/history";
  static readonly HelpPage: string = "/help";
}

export default PageRoutes;
